import { render, staticRenderFns } from "./Fence.vue?vue&type=template&id=60573cf6&scoped=true&"
import script from "./Fence.vue?vue&type=script&lang=js&"
export * from "./Fence.vue?vue&type=script&lang=js&"
import style0 from "./Fence.vue?vue&type=style&index=0&id=60573cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60573cf6",
  null
  
)

export default component.exports